module.exports = __webpack_public_path__ + "static/media/kayaking.13efa922.png";